// extracted by mini-css-extract-plugin
export default {"bottom_sheet":"profile-info_bottom_sheet__kpPTP","input":"profile-info_input__Jv4Mu"};